/**
 * Why this page cannot start: `/config.json` was absent, unreadable or invalid.
 *
 * The message is written for whoever opens the page, because it is shown in place of the
 * application (`runtime-config-failure.ts`). Nothing recovers from it: the bundle has no
 * environment of its own to fall back to, so guessing one would point a page at another
 * environment's API.
 */
export default class RuntimeConfigError extends Error {
  public constructor(message: string, options?: ErrorOptions) {
    super(message, options);
    this.name = "RuntimeConfigError";
  }
}
